import { ref, computed, onBeforeMount, watch, openBlock, createElementBlock, createElementVNode, toDisplayString, unref, Fragment, renderList, createVNode, createTextVNode, createCommentVNode, createBlock, onMounted, withCtx, withDirectives, vShow, vModelCheckbox, normalizeClass, vModelText, Transition, vModelRadio, withKeys, withModifiers, toRaw } from 'vue';
import { u as useSessionStore, a as useAuthStore, I as generateShortUUID, k as db, b as useConfigStore, p as parameter, H as generateUUID, A as addressSchema, c as useAlertStore, w as emailSchema, h as ppapiClient, f as paymentMap, B as bankaccountSchema, n as apiResponse, v as logger } from './prodsel.store-B-MQAyQE.mjs';
import { storeToRefs } from 'pinia';
import { _ } from 'lodash';
import { p as psModal, q as quantityPrice, i as imgsource, k as debounce } from './mediaDocumentChecks-8KYeaHAT.mjs';
import { h as hydrateCartRuntimePrices, r as redirectAction } from './redirectAction-DR1psWNg.mjs';
import { K as script$9, Q as useI18n, f as script$a } from './UserActivate-Bkh4CXdg.mjs';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation, EffectCoverflow, EffectCards } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import 'merkle-json';
import './AutoQueue-Cbuqf1LW.mjs';
import { useRoute, useRouter } from 'vue-router';
import { A as AddressManager, B as BankaccountManager, O as Order } from './BankaccountManager-BQkYKfjP.mjs';

const _hoisted_1$8 = { class: "pp-cart uk-card uk-card-body uk-align-center" };
const _hoisted_2$6 = { key: 0 };
const _hoisted_3$6 = { key: 1 };
const _hoisted_4$6 = { key: 0 };
const _hoisted_5$6 = { class: "item-grid" };
const _hoisted_6$5 = { class: "item-preview" };
const _hoisted_7$5 = { class: "subgrid" };
const _hoisted_8$4 = { class: "item-tools" };
const _hoisted_9$4 = { class: "item-select" };
const _hoisted_10$4 = ["checked", "onChange"];
const _hoisted_11$4 = ["onClick"];
const _hoisted_12$4 = ["onClick"];
const _hoisted_13$4 = { class: "prod-img" };
const _hoisted_14$4 = { class: "item-description" };
const _hoisted_15$3 = { class: "pid uk-text-small" };
const _hoisted_16$3 = {
  key: 0,
  class: "item-options"
};
const _hoisted_17$3 = { class: "prod-copies" };
const _hoisted_18$3 = { class: "uk-text-small" };
const _hoisted_19$3 = ["value", "onChange"];
const _hoisted_20$3 = ["value"];
const _hoisted_21$3 = {
  key: 1,
  class: "prod-quant"
};
const _hoisted_22$3 = { class: "uk-text-small" };
const _hoisted_23$3 = { class: "prod-sp" };
const _hoisted_24$3 = { class: "uk-text-small" };
const _hoisted_25$3 = { class: "item-price" };
const _hoisted_26$3 = { class: "summary-grid" };
const _hoisted_27$2 = {
  key: 0,
  class: "summary-grid"
};
const _hoisted_28$1 = ["disabled"];


var script$8 = {
  __name: 'Cart',
  emits: ['section'],
  setup(__props, { emit: __emit }) {


const sessionStore = useSessionStore();
const authStore = useAuthStore();
const { cart } = storeToRefs(sessionStore);
const cartItemOptions = ref({});
const selectedCartIndexes = ref([]);
const productPricesByItemKey = ref({});
const optionPricesByItemKey = ref({});
const hydratedPriceSignature = ref('');

sessionStore.normalizeCart();
sessionStore.ensureItemRevisions();

const cartItems = computed(() => Array.isArray(cart.value) ? cart.value : (cart.value?.items || []));
const selectedCartItems = computed(() => selectedCartIndexes.value
    .map((index) => cartItems.value[index])
    .filter(Boolean)
);
const selectedTotal = computed(() => selectedCartItems.value.reduce((total, item) => total + (item?.priceCalc?.current || 0), 0));
const canProceedToCheckout = computed(() => selectedCartItems.value.length > 0);

let optionsLoadId = 0;
let pricesLoadId = 0;
let pushCartAfterPriceHydration = false;

//window.cart = cart // DEBUG

const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

const emit = __emit;

function remove(index) {
    selectedCartIndexes.value = selectedCartIndexes.value
        .filter((selectedIndex) => selectedIndex !== index)
        .map((selectedIndex) => (selectedIndex > index ? selectedIndex - 1 : selectedIndex));

    cartItems.value.splice(index, 1);
    sessionStore.scheduleCartPush();
}

function syncSelectedCartEntries({ initializeIfEmpty = false } = {}) {
    const maxIndex = cartItems.value.length - 1;
    selectedCartIndexes.value = selectedCartIndexes.value.filter((index) => index >= 0 && index <= maxIndex);

    if (initializeIfEmpty && selectedCartIndexes.value.length === 0 && cartItems.value.length > 0) {
        selectedCartIndexes.value = cartItems.value.map((_, index) => index);
    }
}

function toggleItemSelection(index, checked) {
    if (checked) {
        if (!selectedCartIndexes.value.includes(index)) {
            selectedCartIndexes.value = [...selectedCartIndexes.value, index];
        }
        return
    }

    selectedCartIndexes.value = selectedCartIndexes.value.filter((entryIndex) => entryIndex !== index);
}

function isSelected(index) {
    return selectedCartIndexes.value.includes(index)
}

function buildSelectorStatusFromCartItem(item) {
    if (!item) return null

    const baseStatus = _.cloneDeep(item.selectorState || {});

    const status = {
        ...baseStatus,
        form: _.cloneDeep(baseStatus.form || {}),
        properties: {
            ..._.cloneDeep(baseStatus.properties || {}),
            ..._.cloneDeep(item.properties || {})
        },
        media: _.cloneDeep(baseStatus.media || item.media || []),
        mediaSettings: _.cloneDeep(baseStatus.mediaSettings || item.mediaSettings || {}),
        product: _.cloneDeep(baseStatus.product || item.product || false),
        productOptionsHash: baseStatus.productOptionsHash || item?.properties?.optionsHash
    };

    if (!status.form.pgrId && status.product?.pgrId) {
        status.form.pgrId = status.product.pgrId;
    }

    if (!status.properties.copies) {
        status.properties.copies = Number(item?.properties?.copies) || 1;
    }

    return status
}

function edit(index) {
    const item = cartItems.value[index];
    const status = buildSelectorStatusFromCartItem(item);
    if (!status) return

    psModal({
        psId: `cart-edit-${Date.now()}`,
        psList: [{ active: true, ...status }],
        useProd: status.product,
        editCartIndex: index,
        bcView: false,
        layout: 'compact'
    });
}


function emptyPriceCalc() {
    return {
        current: 0,
        offer: 0,
        standard: 0,
        currentFmt: fmt.format(0),
        offerFmt: fmt.format(0),
        standardFmt: fmt.format(0),
        currentSingleFmt: fmt.format(0),
        currency: 'EUR',
        explain: []
    }
}

function getRuntimeProductPrices(item, index) {
    return productPricesByItemKey.value[getCartItemKey(item, index)] || []
}

function getRuntimeOptionPrices(item, index) {
    return optionPricesByItemKey.value[getCartItemKey(item, index)] || {}
}

function getCartPriceSignature(items, destinationCountry) {
    return JSON.stringify({
        destinationCountry: destinationCountry || 'DE',
        items: items.map((item) => ({
            id: item?.id,
            productPid: item?.product?.pid,
            optionPids: Array.isArray(item?.selectedOptionPrices)
                ? item.selectedOptionPrices.map((optionPrice) => optionPrice?.pid)
                : []
        }))
    })
}

function createPriceItemsSnapshot() {
    return cartItems.value.map((item) => ({
        id: item?.id,
        product: { pid: item?.product?.pid },
        selectedOptionPrices: Array.isArray(item?.selectedOptionPrices)
            ? item.selectedOptionPrices.map((optionPrice) => ({ pid: optionPrice?.pid }))
            : []
    }))
}

async function hydrateCartPrices() {
    const currentLoadId = ++pricesLoadId;
    const itemsSnapshot = createPriceItemsSnapshot();
    const destinationCountry = sessionStore.checkout?.destinationCountry;
    const priceSignature = getCartPriceSignature(itemsSnapshot, destinationCountry);
    const hydratedRuntimePrices = await hydrateCartRuntimePrices({
        items: itemsSnapshot,
        destinationCountry,
        countryParameter: sessionStore.parameter?.country,
        getItemKey: (item, index) => getCartItemKey(item, index)
    });

    if (currentLoadId !== pricesLoadId || priceSignature !== cartPriceSignature.value) return false

    productPricesByItemKey.value = hydratedRuntimePrices.productPricesByItemKey || {};
    optionPricesByItemKey.value = hydratedRuntimePrices.optionPricesByItemKey || {};
    hydratedPriceSignature.value = priceSignature;
    return true
}


function recalcItem(item, index, num) {

    const mediaItems = Array.isArray(item?.media) ? item.media : [];
    const mediaCount = mediaItems.length || 1;

    let config = {
        options: item.properties.options,
        optionsHash: item.properties.optionsHash
    };
    
    if (mediaItems.length) {
        config.media = mediaItems;
        if (mediaItems[0]?.pages) config.pages = mediaItems[0].pages;
    }

    if (typeof num != "undefined") item.properties.copies = num;
    item.quantity = item.properties.copies * mediaCount;

    const productPrices = getRuntimeProductPrices(item, index);
    if (!Array.isArray(productPrices) || productPrices.length === 0) {
        item.priceCalc = emptyPriceCalc();
        return
    }

    const runtimeProduct = {
        ...(item.product || {}),
        prices: productPrices
    };

    const runtimeOptionPrices = getRuntimeOptionPrices(item, index);
    const selectedOptionPrices = Array.isArray(item.selectedOptionPrices)
        ? item.selectedOptionPrices.map((optionPrice) => ({
            ...(optionPrice || {}),
            prices: runtimeOptionPrices[optionPrice?.pid] || []
        }))
        : [];

    item.priceCalc = quantityPrice(runtimeProduct, item.quantity, config, selectedOptionPrices);
}

async function setQuantity(item, num) {
    // Set quantity and recalculate all items
    if (typeof num != "undefined") {
        const mediaCount = Array.isArray(item?.media) && item.media.length ? item.media.length : 1;
        item.properties.copies = num;
        item.quantity = item.properties.copies * mediaCount;
        item.revision = generateShortUUID();
    }

    if (hydratedPriceSignature.value !== cartPriceSignature.value) {
        pushCartAfterPriceHydration = true;
        await hydrateAndRecalc();
        return
    }

    recalcAll();
    sessionStore.scheduleCartPushDebounced();
}

function getCartItemKey(item, index) {
    if (item?.id) return `id-${item.id}`
    return `${item?.product?.pid || "item"}-${index}`
}

// diskrete Mengenstaffeln (setup.quantities) statt freier Eingabe
function getQuantityOptions(item) {
    return Array.isArray(item?.product?.setup?.quantities) ? item.product.setup.quantities : []
}

function getItemMediaCount(item) {
    return Array.isArray(item?.media) ? item.media.length : 0
}

async function resolveOptionName(optionKey) {
    if (optionKey === null || typeof optionKey === 'undefined' || optionKey === '') return null
    if (Number(optionKey) === 0 || optionKey === 'not_set') return null

    let optionEntry = null;
    const numericKey = Number(optionKey);

    if (!Number.isNaN(numericKey)) {
        optionEntry = await db.productOptions.get(numericKey);
    }

    if (!optionEntry) {
        optionEntry = await db.productOptions.get(optionKey);
    }

    if (!optionEntry && typeof optionKey === 'string') {
        [optionEntry] = await db.productOptions.where('name').equals(optionKey).limit(1).toArray();
    }

    if (!optionEntry || optionEntry.po == 0 || optionEntry.name === 'not_set') return null

    let name = optionEntry.name;

    if (typeof optionEntry?.value === 'string' && optionEntry.value != "") name = `${name} ${optionEntry.value}`;

    return name
}

async function loadCartItemOptions() {
    const currentLoadId = ++optionsLoadId;
    const resolvedOptions = {};

    for (let index = 0; index < cartItems.value.length; index++) {
        const item = cartItems.value[index];
        const selectedOptions = Array.isArray(item?.properties?.options)
            ? item.properties.options
            : (item?.properties?.options ? [item.properties.options] : []);

        resolvedOptions[getCartItemKey(item, index)] = (await Promise.all(selectedOptions.map(resolveOptionName)))
            .filter(Boolean);
    }

    if (currentLoadId !== optionsLoadId) return

    cartItemOptions.value = resolvedOptions;
}

function getResolvedOptions(item, index) {
    return cartItemOptions.value[getCartItemKey(item, index)] || []
}

const cartLength = computed(() => {
    return cartItems.value.length
});

const cartOptionSignature = computed(() => {
    return cartItems.value.map((item) => JSON.stringify(item?.properties?.options || [])).join('|')
});

const cartPriceSignature = computed(() => {
    return getCartPriceSignature(cartItems.value, sessionStore.checkout?.destinationCountry)
});

function recalcAll() {
    cartItems.value.forEach((item, index) => {
        recalcItem(item, index);
    });
}

async function hydrateAndRecalc() {
    if (!await hydrateCartPrices()) return false

    recalcAll();
    if (pushCartAfterPriceHydration) {
        pushCartAfterPriceHydration = false;
        sessionStore.scheduleCartPushDebounced();
    }
    return true
}

function startCheckout() {
    if (!canProceedToCheckout.value) return

    sessionStore.initCheckout(selectedCartItems.value);
    emit('section', 'delivery');
}

async function syncCartOnLoad() {
    const currentKid = authStore.user?.kid;
    if (currentKid) {
        await sessionStore.syncCartFromServer(currentKid, { authoritative: true });
    }
}

onBeforeMount(() => {
    syncCartOnLoad().finally(async () => {
        await hydrateAndRecalc();
        loadCartItemOptions();
        syncSelectedCartEntries({ initializeIfEmpty: true });
    });
});

// Bei hinzufügen oder löschen von Cart Positionen alles neu berechnen (wegen Staffelpreisen)
watch(cartLength, () => {
    loadCartItemOptions();
    syncSelectedCartEntries();
});

watch(cartOptionSignature, () => {
    if (hydratedPriceSignature.value === cartPriceSignature.value) recalcAll();
    loadCartItemOptions();
});

watch(cartPriceSignature, () => {
    hydrateAndRecalc();
});



return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$8, [
    createElementVNode("h3", null, toDisplayString(_ctx.$t('checkout.cart.title')), 1 /* TEXT */),
    (unref(_).size(cartItems.value) == 0)
      ? (openBlock(), createElementBlock("div", _hoisted_2$6, toDisplayString(_ctx.$t('checkout.cart.empty')), 1 /* TEXT */))
      : (openBlock(), createElementBlock("div", _hoisted_3$6, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(cartItems.value, (item, index) => {
            return (openBlock(), createElementBlock("div", {
              key: getCartItemKey(item, index)
            }, [
              (item.product)
                ? (openBlock(), createElementBlock("div", _hoisted_4$6, [
                    createElementVNode("div", _hoisted_5$6, [
                      createElementVNode("div", _hoisted_6$5, [
                        createElementVNode("div", _hoisted_7$5, [
                          createElementVNode("div", _hoisted_8$4, [
                            createElementVNode("label", _hoisted_9$4, [
                              createElementVNode("input", {
                                type: "checkbox",
                                class: "uk-checkbox",
                                checked: isSelected(index),
                                onChange: $event => (toggleItemSelection(index, $event.target.checked))
                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10$4)
                            ]),
                            createElementVNode("button", {
                              "uk-icon": "icon: trash",
                              onClick: $event => (remove(index))
                            }, null, 8 /* PROPS */, _hoisted_11$4),
                            createElementVNode("button", {
                              "uk-icon": "icon: cog",
                              onClick: $event => (edit(index))
                            }, null, 8 /* PROPS */, _hoisted_12$4)
                          ]),
                          createElementVNode("div", _hoisted_13$4, [
                            createVNode(unref(script$7), { item: item }, null, 8 /* PROPS */, ["item"])
                          ])
                        ])
                      ]),
                      createElementVNode("div", _hoisted_14$4, [
                        createElementVNode("div", null, [
                          createTextVNode(toDisplayString(item.product.label) + " " + toDisplayString(item.product.format) + "   ", 1 /* TEXT */),
                          createElementVNode("span", _hoisted_15$3, "(" + toDisplayString(_ctx.$t('checkout.cart.articleNumber', { pid: item.product.pid })) + ")", 1 /* TEXT */)
                        ]),
                        (getResolvedOptions(item, index).length)
                          ? (openBlock(), createElementBlock("div", _hoisted_16$3, [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(getResolvedOptions(item, index), (optionName, optionIndex) => {
                                return (openBlock(), createElementBlock("span", {
                                  key: `${optionName}-${optionIndex}`,
                                  class: "product-option"
                                }, toDisplayString(_ctx.$t('product.' + optionName) !== ('product.' + optionName)
                                        ? _ctx.$t('product.' + optionName)
                                        : optionName), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : createCommentVNode("v-if", true),
                        createElementVNode("div", _hoisted_17$3, [
                          createElementVNode("div", _hoisted_18$3, toDisplayString(_ctx.$t('checkout.cart.copies')), 1 /* TEXT */),
                          (getQuantityOptions(item).length)
                            ? (openBlock(), createElementBlock("select", {
                                key: 0,
                                value: item.properties.copies,
                                class: "uk-select uk-form-small",
                                onChange: (e) => setQuantity(item, e.target.value)
                              }, [
                                (openBlock(true), createElementBlock(Fragment, null, renderList(getQuantityOptions(item), (qty) => {
                                  return (openBlock(), createElementBlock("option", {
                                    key: qty,
                                    value: qty
                                  }, toDisplayString(qty), 9 /* TEXT, PROPS */, _hoisted_20$3))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_19$3))
                            : (openBlock(), createBlock(unref(script$9), {
                                key: 1,
                                min: "1",
                                num: item.properties.copies,
                                showInput: "true",
                                width: "30",
                                onChange: (...args) => setQuantity(item, ...args)
                              }, null, 8 /* PROPS */, ["num", "onChange"]))
                        ]),
                        (getItemMediaCount(item) > 1)
                          ? (openBlock(), createElementBlock("div", _hoisted_21$3, [
                              createElementVNode("div", _hoisted_22$3, toDisplayString(_ctx.$t('checkout.cart.quantity')), 1 /* TEXT */),
                              createElementVNode("span", null, toDisplayString(item.quantity), 1 /* TEXT */)
                            ]))
                          : createCommentVNode("v-if", true),
                        createElementVNode("div", _hoisted_23$3, [
                          createElementVNode("div", _hoisted_24$3, toDisplayString(_ctx.$t('checkout.cart.unitPrice')), 1 /* TEXT */),
                          createElementVNode("div", null, toDisplayString(item.priceCalc.currentSingleFmt), 1 /* TEXT */)
                        ])
                      ]),
                      createElementVNode("div", _hoisted_25$3, toDisplayString(item.priceCalc.currentFmt), 1 /* TEXT */)
                    ])
                  ]))
                : createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          createElementVNode("div", _hoisted_26$3, [
            createElementVNode("div", null, toDisplayString(_ctx.$t('checkout.cart.total')), 1 /* TEXT */),
            createElementVNode("div", null, toDisplayString(unref(fmt).format(cartItems.value.reduce((a, el) => a + el.priceCalc.current, 0))), 1 /* TEXT */)
          ]),
          (selectedCartItems.value.length !== cartItems.value.length)
            ? (openBlock(), createElementBlock("div", _hoisted_27$2, [
                createElementVNode("div", null, toDisplayString(_ctx.$t('checkout.cart.selectedTotal')), 1 /* TEXT */),
                createElementVNode("div", null, toDisplayString(unref(fmt).format(selectedTotal.value)), 1 /* TEXT */)
              ]))
            : createCommentVNode("v-if", true),
          createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => (startCheckout())),
            disabled: !canProceedToCheckout.value,
            class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary"
          }, toDisplayString(_ctx.$t('checkout.cart.toShippingOptions')), 9 /* TEXT, PROPS */, _hoisted_28$1)
        ]))
  ]))
}
}

};

script$8.__file = "src/components/checkout/Cart.vue";

const _hoisted_1$7 = { class: "cart-item-preview" };
const _hoisted_2$5 = { class: "slide" };
const _hoisted_3$5 = ["src"];
const _hoisted_4$5 = { class: "slide" };
const _hoisted_5$5 = ["src"];
const _hoisted_6$4 = { class: "slide cart-preview-fallback" };
const _hoisted_7$4 = { class: "fallback-text" };


var script$7 = {
  __name: 'CartItemPreview',
  props: {
    item: Object
},
  setup(__props) {


const modules = [Pagination, Navigation, EffectCoverflow, EffectCards];

const props = __props;

const { t } = useI18n();
const configStore = useConfigStore();
const mediaItems = computed(() => Array.isArray(props.item?.media) ? props.item.media : []);
const productBgImageUrl = ref('');
const previewKey = computed(() => {
    const mediaKey = mediaItems.value
        .map((media) => media?.id ?? media?.jid ?? media?.bid ?? media?.uid ?? '')
        .join('|');

    return [
        props.item?.revision || '',
        props.item?.product?.pid || '',
        mediaKey,
        productBgImageUrl.value ? 'bg' : 'empty'
    ].join('::')
});

function getProductBgImageUrl(imageUrl) {
    const contentBase = configStore.contentBase;
    if (!imageUrl || !contentBase) return ''

    return contentBase.replace(/\/+$/, '') + imageUrl
}

async function fetchProductBgImage() {
    productBgImageUrl.value = '';

    if (mediaItems.value.length > 0) return

    const contentBase = configStore.contentBase;
    const form = props.item?.selectorState?.form;
    const productPid = props.item?.product?.pid;

    if (!contentBase || !form) return

    const params = new URLSearchParams();
    const SKIP_KEYS = new Set(['preFilter', 'pid']);
    const SKIP_PREFIXES = ['confirm_', 'po_'];

    for (const [key, value] of Object.entries(form)) {
        if (SKIP_KEYS.has(key)) continue
        if (SKIP_PREFIXES.some((prefix) => key.startsWith(prefix))) continue
        if (value === null || value === undefined || value === '') continue
        if (typeof value !== 'string' && typeof value !== 'number') continue
        params.set(key, String(value));
    }

    if (productPid) {
        params.set('pid', String(productPid));
    }

    try {
        const base = contentBase.replace(/\/+$/, '');
        const query = params.toString();
        const url = query ? `${base}/api/products/images?${query}` : `${base}/api/products/images`;
        const response = await fetch(url);
        if (!response.ok) return

        const json = await response.json();
        const imageUrl = json?.data?.imageUrl;
        productBgImageUrl.value = getProductBgImageUrl(imageUrl);
    } catch {
        productBgImageUrl.value = '';
    }
}

watch(
    () => [
        props.item?.revision,
        props.item?.product?.pid,
        JSON.stringify(props.item?.selectorState?.form || {})
    ],
    () => {
        fetchProductBgImage();
    },
    { immediate: true }
);

onMounted(() => {
    fetchProductBgImage();
});



return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$7, [
    (openBlock(), createBlock(unref(Swiper), {
      key: previewKey.value,
      class: "mySwiper",
      modules: modules,
      navigation: { enabled: true, nextEl: '.sw-next', prevEl: '.sw-prev' },
      pagination: { type: 'fraction', el: '.swp' },
      effect: 'cards',
      centeredSlides: true,
      slidesPerView: 'auto'
    }, {
      default: withCtx(() => [
        createCommentVNode(" Slides "),
        (openBlock(true), createElementBlock(Fragment, null, renderList(mediaItems.value, (media, i) => {
          return (openBlock(), createBlock(unref(SwiperSlide), { key: i }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2$5, [
                createElementVNode("img", {
                  src: unref(imgsource)(media, 'th')
                }, null, 8 /* PROPS */, _hoisted_3$5)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */)),
        (mediaItems.value.length === 0 && productBgImageUrl.value)
          ? (openBlock(), createBlock(unref(SwiperSlide), { key: "product-bg-preview" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4$5, [
                  createElementVNode("img", { src: productBgImageUrl.value }, null, 8 /* PROPS */, _hoisted_5$5)
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : createCommentVNode("v-if", true),
        (mediaItems.value.length === 0 && !productBgImageUrl.value)
          ? (openBlock(), createBlock(unref(SwiperSlide), { key: "empty-preview-fallback" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_6$4, [
                  _cache[0] || (_cache[0] = createElementVNode("div", {
                    class: "fallback-icon",
                    "uk-icon": "icon: image"
                  }, null, -1 /* HOISTED */)),
                  createElementVNode("div", _hoisted_7$4, toDisplayString(unref(t)('checkout.cart.noPreviewImage')), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : createCommentVNode("v-if", true),
        withDirectives(createElementVNode("div", null, _cache[1] || (_cache[1] = [
          createElementVNode("div", {
            "uk-icon": "icon: chevron-left",
            class: "sw-prev"
          }, null, -1 /* HOISTED */),
          createElementVNode("div", { class: "swp" }, null, -1 /* HOISTED */),
          createElementVNode("div", {
            "uk-icon": "icon: chevron-right",
            class: "sw-next"
          }, null, -1 /* HOISTED */)
        ]), 512 /* NEED_PATCH */), [
          [vShow, mediaItems.value.length > 1]
        ])
      ]),
      _: 1 /* STABLE */
    }))
  ]))
}
}

};

script$7.__file = "src/components/checkout/CartItemPreview.vue";

const _hoisted_1$6 = { class: "uk-card uk-card-body uk-align-center checkout-addresses" };
const _hoisted_2$4 = { key: 0 };
const _hoisted_3$4 = {
  key: 0,
  style: {"max-width":"300px"},
  class: "uk-margin"
};
const _hoisted_4$4 = { key: 1 };
const _hoisted_5$4 = { class: "wmax300" };
const _hoisted_6$3 = { key: 0 };
const _hoisted_7$3 = { class: "uk-align-right" };
const _hoisted_8$3 = { class: "uk-margin" };
const _hoisted_9$3 = {
  key: 2,
  class: "uk-margin wmax300"
};
const _hoisted_10$3 = {
  key: 0,
  style: {"max-width":"300px"},
  class: "uk-margin"
};
const _hoisted_11$3 = { key: 1 };
const _hoisted_12$3 = { class: "wmax300" };
const _hoisted_13$3 = { key: 0 };
const _hoisted_14$3 = { class: "uk-align-right" };


var script$6 = {
  __name: 'OrderAddresses',
  emits: ['section',"is-valid"],
  setup(__props, { emit: __emit }) {

const sessionStore = useSessionStore();
const authStore = useAuthStore();
const { checkout, addresses } = storeToRefs(sessionStore);


//window.checkout = checkout // DEBUG

const countries = ref({});
const verified = ref(false);
const raddr = ref({});
const laddr = ref({});
const edit = ref({R:false, L:false});
const invoiceAddressIsValid = ref(false);
const deliveryAddressIsValid = ref(false);

const emit = __emit;

parameter.country.then(data => {
    if (data?.country_list) countries.value = data.country_list;
});

function getAddressLines(addr) {
    if (!addr) return []

    return [
        addr.company,
        [addr.firstname, addr.lastname].filter(Boolean).join(' ').trim(),
        addr.ustid ? `USt-IdNr.: ${addr.ustid}` : '',
        addr.street,
        addr.supplement,
        [addr.zip, addr.city || addr.ort].filter(Boolean).join(' ').trim(),
        countries.value[addr.countryISO || addr.country] || addr.countryISO || addr.country || ''
    ].filter((line) => String(line || '').trim())
}


const am = new AddressManager();

async function initAddresses() {
        await am.init();
        setAddress("L", am.laddr);
        setAddress("R", am.raddr);
        invoiceAddressIsValid.value = verifyAddress(am.raddr, "R");
        deliveryAddressIsValid.value = verifyAddress(am.laddr, "L");
}

am.onAddrChange = (type, addr) => {
    if (type == "R") {
        raddr.value = addr;
    } else if (type == "L") {
        laddr.value = addr;
    }
};


onBeforeMount(() => {
    // Initializing addresses and setting up the address selection
    initAddresses();
});

// whatch user auth and init again if state changes
watch(() => authStore.user, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        initAddresses();
    }
}, { immediate: true });

function setShippingAddress(data) {
    if (!data) return

    setAddress("L", data.address, data.sid, "update");

}

function setInvoiceAddress(data) {

    if (!data) return

    setAddress("R", data.address, data.sid, "update" );
   
}

function setAddress(type, addr, sid, cmd) {

    if (addr && !addr.sid) {
        addr.sid = generateUUID('_');
    }

    if (sid == "0" || sid == 0) {
        let newAddr = am.addAddr(type); 
        checkout.value.addresses[type] = newAddr.sid;
    } else if (sid) {
        let listElem = addresses.value.rawData.find((el) => el && el.sid == sid);
        if (listElem) {
            am.setAddr(type,listElem);
            checkout.value.addresses[type] = listElem.sid;
        }
        if (type == "R") invoiceAddressIsValid.value = verifyAddress(am.raddr, "R");
        if (type == "L") deliveryAddressIsValid.value = verifyAddress(am.laddr, "L");
    }

    if (!addr) return

    addr = am.setAddr(type, addr, cmd);

    checkout.value.addresses[type] = addr.sid;
    if (!Array.isArray(addresses.value.rawData)) addresses.value.rawData = [];
    let listElem = addresses.value.rawData.find((el) => el && el.sid == addr.sid);
    if (listElem) addresses.value.rawData.splice(addresses.value.rawData.indexOf(listElem), 1, addr);
    else  addresses.value.rawData.push(addr);

}

function verifyAddress(addr, setEdit) {

    try {
        addressSchema.validateSync(addr);
        if (setEdit && typeof edit.value == "object") edit.value[setEdit] = false;
        verified.value = true;
    } catch (err) {
        // Automatisches setzen der edit flag, wenn unvollständig
        if (setEdit && typeof edit.value == "object") edit.value[setEdit] = true;
        verified.value = false;
    }

    return verified.value

}

const addressesAreValid = computed(() => { 

    let shippingIsValid =  (!checkout.value.altDelivery || (checkout.value.altDelivery && deliveryAddressIsValid.value)); 
    return invoiceAddressIsValid.value && shippingIsValid
});

watch(addressesAreValid,(newValue) => {
    emit('is-valid', newValue);
});


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("h3", null, [
      createTextVNode(toDisplayString(_ctx.$t('checkout.addresses.billingAddress')), 1 /* TEXT */),
      (!unref(checkout).altDelivery)
        ? (openBlock(), createElementBlock("span", _hoisted_2$4, toDisplayString(_ctx.$t('checkout.addresses.billingDeliverySame')), 1 /* TEXT */))
        : createCommentVNode("v-if", true)
    ]),
    (edit.value.R)
      ? (openBlock(), createElementBlock("div", _hoisted_3$4, [
          createElementVNode("div", null, [
            (unref(addresses).loaded)
              ? (openBlock(), createBlock(unref(script$a), {
                  key: 0,
                  onOnSelect: setInvoiceAddress,
                  onIsValid: _cache[0] || (_cache[0] = (d) => invoiceAddressIsValid.value = d),
                  addresses: unref(addresses),
                  addrId: raddr.value.sid
                }, null, 8 /* PROPS */, ["addresses", "addrId"]))
              : createCommentVNode("v-if", true)
          ])
        ]))
      : (openBlock(), createElementBlock("div", _hoisted_4$4, [
          createElementVNode("div", _hoisted_5$4, [
            (raddr.value && unref(addresses).loaded)
              ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
                  createElementVNode("div", _hoisted_7$3, [
                    createElementVNode("a", {
                      href: "#",
                      onClick: _cache[1] || (_cache[1] = () => edit.value.R = true),
                      class: "uk-icon",
                      "uk-icon": "icon: file-edit"
                    })
                  ]),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(getAddressLines(raddr.value), (line, index) => {
                    return (openBlock(), createElementBlock("div", {
                      key: `raddr-${index}`
                    }, toDisplayString(line), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : createCommentVNode("v-if", true)
          ])
        ])),
    createElementVNode("div", _hoisted_8$3, [
      withDirectives(createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((unref(checkout).altDelivery) = $event)),
        class: "uk-checkbox"
      }, null, 512 /* NEED_PATCH */), [
        [vModelCheckbox, unref(checkout).altDelivery]
      ]),
      createTextVNode(" " + toDisplayString(_ctx.$t('checkout.addresses.altDeliveryAddress')), 1 /* TEXT */)
    ]),
    (unref(checkout).altDelivery)
      ? (openBlock(), createElementBlock("div", _hoisted_9$3, [
          createElementVNode("h3", null, toDisplayString(_ctx.$t('checkout.addresses.deliveryAddress')), 1 /* TEXT */),
          (edit.value.L)
            ? (openBlock(), createElementBlock("div", _hoisted_10$3, [
                createElementVNode("div", null, [
                  (unref(addresses).loaded)
                    ? (openBlock(), createBlock(unref(script$a), {
                        key: 0,
                        onOnSelect: setShippingAddress,
                        onIsValid: _cache[3] || (_cache[3] = (d) => deliveryAddressIsValid.value = d),
                        addresses: unref(addresses),
                        addrId: laddr.value.sid
                      }, null, 8 /* PROPS */, ["addresses", "addrId"]))
                    : createCommentVNode("v-if", true)
                ])
              ]))
            : (openBlock(), createElementBlock("div", _hoisted_11$3, [
                createElementVNode("div", _hoisted_12$3, [
                  (laddr.value && unref(addresses).loaded)
                    ? (openBlock(), createElementBlock("div", _hoisted_13$3, [
                        createElementVNode("div", _hoisted_14$3, [
                          createElementVNode("a", {
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = () => edit.value.L = true),
                            class: "uk-icon",
                            "uk-icon": "icon: file-edit"
                          })
                        ]),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(getAddressLines(laddr.value), (line, index) => {
                          return (openBlock(), createElementBlock("div", {
                            key: `laddr-${index}`
                          }, toDisplayString(line), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : createCommentVNode("v-if", true)
                ])
              ]))
        ]))
      : createCommentVNode("v-if", true)
  ]))
}
}

};

script$6.__file = "src/components/checkout/OrderAddresses.vue";

const _hoisted_1$5 = { class: "uk-card uk-card-body uk-align-center checkout-user-email" };
const _hoisted_2$3 = {
  class: "uk-margin",
  style: {"max-width":"300px"}
};
const _hoisted_3$3 = {
  key: 0,
  class: "uk-margin"
};
const _hoisted_4$3 = { class: "uk-form-label" };
const _hoisted_5$3 = {
  class: "uk-text-bold uk-padding-small uk-background-muted",
  style: {"padding":"10px 15px","border-radius":"4px"}
};
const _hoisted_6$2 = { class: "uk-margin" };
const _hoisted_7$2 = { class: "uk-form-label" };
const _hoisted_8$2 = { class: "email-input-row" };
const _hoisted_9$2 = ["placeholder", "disabled"];
const _hoisted_10$2 = ["disabled", "title", "aria-label"];
const _hoisted_11$2 = {
  key: 0,
  class: "uk-text-danger uk-text-small uk-margin-small-top"
};
const _hoisted_12$2 = {
  key: 0,
  class: "uk-margin"
};
const _hoisted_13$2 = { class: "uk-margin-small-bottom" };
const _hoisted_14$2 = {
  key: 0,
  class: "uk-margin-small-top uk-text-muted uk-text-small"
};
const _hoisted_15$2 = {
  key: 0,
  class: "uk-margin uk-alert uk-alert-warning uk-alert-small"
};
const _hoisted_16$2 = { class: "uk-text-small uk-margin-remove" };
const _hoisted_17$2 = { class: "uk-margin-small-top" };
const _hoisted_18$2 = { class: "uk-form-label" };
const _hoisted_19$2 = ["placeholder", "disabled"];
const _hoisted_20$2 = { class: "uk-margin-small-top" };
const _hoisted_21$2 = {
  key: 0,
  class: "uk-margin-small-top forgot-password-form"
};
const _hoisted_22$2 = { class: "uk-text-small" };
const _hoisted_23$2 = ["disabled"];
const _hoisted_24$2 = ["disabled"];
const _hoisted_25$2 = {
  key: 0,
  "uk-spinner": "ratio: 0.8"
};
const _hoisted_26$2 = {
  key: 0,
  class: "uk-text-small uk-text-muted uk-margin-top"
};


var script$5 = {
  __name: 'UserEmail',
  emits: ['is-valid'],
  setup(__props, { emit: __emit }) {

const sessionStore = useSessionStore();
const authStore = useAuthStore();
const configStore = useConfigStore();
const alertStore = useAlertStore();
const { checkout } = storeToRefs(sessionStore);
const { user } = storeToRefs(authStore);
const { t } = useI18n({ useScope: 'global' });

const emit = __emit;

const email = ref('');
const password = ref('');
const validationError = ref('');
const isValidating = ref(false);
const userExists = ref(false);
const passwordFieldVisible = ref(false);
const isLoggingIn = ref(false);
const loginError = ref(false);
const forgotPasswordOpen = ref(false);
const forgotPasswordMessageKey = ref('');
const forgotPasswordSubmitting = ref(false);

const emailValidated = ref(false);
const registerMode = ref(null); // null | 'register' | 'guest'

const isLoggedIn = computed(() => !!user.value?.token);

// Bei Mount: Email aus User- oder Session-Kontext laden
onMounted(async () => {
  if (isLoggedIn.value && authStore.user?.username) {
    email.value = authStore.user.email;
    emit('is-valid', true);
    return
  }

  if (!isLoggedIn.value && checkout.value?.email) {
    email.value = checkout.value.email;
    
    // If email is set vom previous session, validate it immediately
    await validateEmail();

    if (typeof checkout.value.login === 'boolean') {
      registerMode.value = checkout.value.login ? 'register' : 'guest';
      emailValidated.value = true;
      emit('is-valid', true);
      return
    }

    // Legacy-Fallback: alte registerMode-Werte in login-Flag überführen.
    if (checkout.value.registerMode === 'guest' || checkout.value.registerMode === 'register') {
      registerMode.value = checkout.value.registerMode;
      checkout.value.login = registerMode.value === 'register';
      emailValidated.value = true;
      emit('is-valid', true);
    } else {
      emailValidated.value = true;
      registerMode.value = null;
      emit('is-valid', false);
    }
  }
});

// Email-Validierung
async function validateEmail() {
  if (isValidating.value) return

  const normalizedEmail = String(email.value || '').trim();
  email.value = normalizedEmail;

  if (!normalizedEmail) {
    validationError.value = '';
    userExists.value = false;
    passwordFieldVisible.value = false;
    emit('is-valid', false);
    return
  }

  if (!emailSchema.isValidSync(normalizedEmail)) {
    validationError.value = t('checkout.userEmail.invalidEmail');
    userExists.value = false;
    passwordFieldVisible.value = false;
    emailValidated.value = false;
    registerMode.value = null;
    checkout.value.email = null;
    checkout.value.login = null;
    checkout.value.registerMode = null;
    emit('is-valid', false);
    return
  }

  isValidating.value = true;
  validationError.value = '';
  loginError.value = false;

  try {
    const response = await ppapiClient.post('validate', {
      email: normalizedEmail,
      app: configStore.app
    });

    // Benutzer existiert
    if (response && response.id) {
      userExists.value = true;
      passwordFieldVisible.value = true;
      checkout.value.email = null;
      checkout.value.login = null;
      checkout.value.registerMode = null;
      emit('is-valid', false); // nicht valid bis login
    } else {
      // Benutzer existiert nicht - Modus wählen lassen
      userExists.value = false;
      passwordFieldVisible.value = false;
      emailValidated.value = true;
      registerMode.value = null;
      checkout.value.email = normalizedEmail;
      checkout.value.login = null;
      checkout.value.registerMode = null;
      emit('is-valid', false); // erst nach Modus-Auswahl valid
    }
  } catch (error) {
    // Bei Fehler: wahrscheinlich kein Benutzer mit dieser Email
    userExists.value = false;
    passwordFieldVisible.value = false;
    emailValidated.value = true;
    registerMode.value = null;
    checkout.value.email = normalizedEmail;
    checkout.value.login = null;
    checkout.value.registerMode = null;
    emit('is-valid', false);
  }

  isValidating.value = false;
}

function resetEmailValidationState() {
  validationError.value = '';
  loginError.value = false;
  emailValidated.value = false;
  registerMode.value = null;
}

// Email-Validierung beim Unfocus
function onEmailBlur() {
  resetEmailValidationState();
  validateEmail();
}

function onValidateEmailClick() {
  resetEmailValidationState();
  validateEmail();
}

// Modus-Auswahl (Konto anlegen / Gast)
function onRegisterModeChange() {
  checkout.value.registerMode = registerMode.value;
  checkout.value.login = registerMode.value === 'register';

  if (registerMode.value === 'guest' || registerMode.value === 'register') {
    emit('is-valid', true);
  } else {
    emit('is-valid', false);
  }
}

function openForgotPassword() {
  forgotPasswordOpen.value = true;
  forgotPasswordMessageKey.value = '';
}

async function submitForgotPassword() {
  const forgotEmail = String(email.value || '').trim();

  if (!forgotEmail) {
    forgotPasswordMessageKey.value = 'checkout.userEmail.forgotPasswordEmailRequired';
    return
  }

  if (!emailSchema.isValidSync(forgotEmail)) {
    forgotPasswordMessageKey.value = 'checkout.userEmail.forgotPasswordEmailInvalid';
    return
  }

  forgotPasswordSubmitting.value = true;
  forgotPasswordMessageKey.value = '';

  try {
    await ppapiClient.post('password/forgot', {
      email: forgotEmail,
      app: configStore.app
    });
    forgotPasswordMessageKey.value = 'checkout.userEmail.forgotPasswordSuccess';
    forgotPasswordOpen.value = false;
  } catch (error) {
    forgotPasswordMessageKey.value = 'checkout.userEmail.forgotPasswordFailed';
  } finally {
    forgotPasswordSubmitting.value = false;
  }
}

async function loginWithEmail() {
  if (!email.value || !password.value) {
    alertStore.error('Email und Passwort sind erforderlich', 'checkout');
    loginError.value = true;
    return
  }

  isLoggingIn.value = true;
  loginError.value = false;
  checkout.value.selectStandardInvoiceAddressAfterLogin = true;

  const result = await authStore.login(email.value, password.value, 'checkout');

  if (result && result.token) {
    // Login erfolgreich
    password.value = '';
    checkout.value.email = null;
    checkout.value.login = null;
    checkout.value.registerMode = null;
    emit('is-valid', true);
  } else {
    checkout.value.selectStandardInvoiceAddressAfterLogin = false;
    loginError.value = true;
  }

  isLoggingIn.value = false;
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("h3", null, toDisplayString(_ctx.$t('checkout.userEmail.title')), 1 /* TEXT */),
    createElementVNode("div", _hoisted_2$3, [
      createCommentVNode(" Eingeloggte Nutzer: Email als Read-Only Anzeige "),
      (isLoggedIn.value)
        ? (openBlock(), createElementBlock("div", _hoisted_3$3, [
            createElementVNode("label", _hoisted_4$3, toDisplayString(_ctx.$t('checkout.userEmail.emailLabel')), 1 /* TEXT */),
            createElementVNode("div", _hoisted_5$3, toDisplayString(email.value), 1 /* TEXT */)
          ]))
        : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createCommentVNode(" Nicht eingeloggte Nutzer: Email-Formular "),
            createCommentVNode(" Email Input "),
            createElementVNode("div", _hoisted_6$2, [
              createElementVNode("label", _hoisted_7$2, toDisplayString(_ctx.$t('checkout.userEmail.emailLabel')), 1 /* TEXT */),
              createElementVNode("div", _hoisted_8$2, [
                withDirectives(createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((email).value = $event)),
                  onBlur: onEmailBlur,
                  type: "email",
                  class: normalizeClass(["uk-input", { 'uk-form-danger': validationError.value }]),
                  placeholder: _ctx.$t('checkout.userEmail.emailPlaceholder'),
                  disabled: isValidating.value || isLoggingIn.value
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_9$2), [
                  [vModelText, email.value]
                ]),
                createElementVNode("button", {
                  type: "button",
                  class: "uk-button uk-button-small email-verify-button",
                  disabled: !email.value || isValidating.value || isLoggingIn.value,
                  onClick: onValidateEmailClick,
                  title: _ctx.$t('checkout.userEmail.verifyEmail'),
                  "aria-label": _ctx.$t('checkout.userEmail.verifyEmail')
                }, _cache[4] || (_cache[4] = [
                  createElementVNode("span", { "uk-icon": "check" }, null, -1 /* HOISTED */)
                ]), 8 /* PROPS */, _hoisted_10$2)
              ]),
              (validationError.value)
                ? (openBlock(), createElementBlock("div", _hoisted_11$2, toDisplayString(validationError.value), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ]),
            createCommentVNode(" Modus-Auswahl (Konto anlegen / Gast) wenn Benutzer nicht existiert "),
            createVNode(Transition, { name: "slide-down" }, {
              default: withCtx(() => [
                (emailValidated.value && !userExists.value && !isValidating.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_12$2, [
                      createElementVNode("div", _hoisted_13$2, [
                        createElementVNode("label", null, [
                          withDirectives(createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((registerMode).value = $event)),
                            type: "radio",
                            value: "register",
                            class: "uk-radio",
                            onChange: onRegisterModeChange
                          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [vModelRadio, registerMode.value]
                          ]),
                          _cache[5] || (_cache[5] = createTextVNode("  Benutzerkonto anlegen ")),
                          _cache[6] || (_cache[6] = createElementVNode("span", { class: "uk-text-muted uk-text-small" }, "(Auftragsverwaltung, Bildergalerie)", -1 /* HOISTED */))
                        ])
                      ]),
                      createElementVNode("div", null, [
                        createElementVNode("label", null, [
                          withDirectives(createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((registerMode).value = $event)),
                            type: "radio",
                            value: "guest",
                            class: "uk-radio",
                            onChange: onRegisterModeChange
                          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [vModelRadio, registerMode.value]
                          ]),
                          _cache[7] || (_cache[7] = createTextVNode("  Als Gast bestellen ")),
                          _cache[8] || (_cache[8] = createElementVNode("span", { class: "uk-text-muted uk-text-small" }, "(keine Auftragsverfolgung)", -1 /* HOISTED */))
                        ])
                      ]),
                      (registerMode.value === 'register')
                        ? (openBlock(), createElementBlock("div", _hoisted_14$2, " Sie erhalten nach der Bestellung eine E-Mail mit Link zum Passwort setzen. "))
                        : createCommentVNode("v-if", true)
                    ]))
                  : createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            createCommentVNode(" Passwort-Feld (mit Animation wenn Benutzer existiert) "),
            createVNode(Transition, { name: "slide-down" }, {
              default: withCtx(() => [
                (passwordFieldVisible.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_15$2, [
                      createElementVNode("p", _hoisted_16$2, toDisplayString(_ctx.$t('checkout.userEmail.userExists', { email: email.value })), 1 /* TEXT */),
                      createElementVNode("div", _hoisted_17$2, [
                        createElementVNode("label", _hoisted_18$2, toDisplayString(_ctx.$t('checkout.userEmail.passwordLabel')), 1 /* TEXT */),
                        withDirectives(createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((password).value = $event)),
                          type: "password",
                          class: normalizeClass(["uk-input", { 'uk-form-danger': loginError.value }]),
                          placeholder: _ctx.$t('checkout.userEmail.passwordPlaceholder'),
                          disabled: isLoggingIn.value,
                          onKeyup: withKeys(loginWithEmail, ["enter"])
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_19$2), [
                          [vModelText, password.value]
                        ])
                      ]),
                      createElementVNode("div", _hoisted_20$2, [
                        createElementVNode("a", {
                          href: "#",
                          class: "forgot-password-link",
                          onClick: withModifiers(openForgotPassword, ["prevent"])
                        }, toDisplayString(_ctx.$t('checkout.userEmail.forgotPasswordLink')), 1 /* TEXT */),
                        (forgotPasswordOpen.value)
                          ? (openBlock(), createElementBlock("div", _hoisted_21$2, [
                              createElementVNode("div", _hoisted_22$2, toDisplayString(_ctx.$t('checkout.userEmail.forgotPasswordResetFor', { email: email.value })), 1 /* TEXT */),
                              createElementVNode("button", {
                                type: "button",
                                class: "uk-button uk-button-default uk-button-small",
                                disabled: forgotPasswordSubmitting.value,
                                onClick: submitForgotPassword
                              }, toDisplayString(_ctx.$t('checkout.userEmail.forgotPasswordSubmit')), 9 /* TEXT, PROPS */, _hoisted_23$2)
                            ]))
                          : createCommentVNode("v-if", true),
                        (forgotPasswordMessageKey.value)
                          ? (openBlock(), createElementBlock("div", {
                              key: 1,
                              class: normalizeClass(["uk-text-small uk-margin-small-top", forgotPasswordOpen.value ? 'uk-text-danger' : 'uk-text-success'])
                            }, toDisplayString(_ctx.$t(forgotPasswordMessageKey.value)), 3 /* TEXT, CLASS */))
                          : createCommentVNode("v-if", true)
                      ]),
                      createElementVNode("button", {
                        onClick: loginWithEmail,
                        disabled: !email.value || !password.value || isLoggingIn.value,
                        class: "uk-button uk-button-primary uk-button-small uk-margin-small-top"
                      }, [
                        (isLoggingIn.value)
                          ? (openBlock(), createElementBlock("span", _hoisted_25$2))
                          : createCommentVNode("v-if", true),
                        createTextVNode(" " + toDisplayString(_ctx.$t('checkout.userEmail.loginButton')), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_24$2)
                    ]))
                  : createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            createCommentVNode(" Ladeanzeige während Validierung "),
            (isValidating.value)
              ? (openBlock(), createElementBlock("div", _hoisted_26$2, [
                  _cache[9] || (_cache[9] = createElementVNode("span", { "uk-spinner": "ratio: 0.8" }, null, -1 /* HOISTED */)),
                  createTextVNode(" " + toDisplayString(_ctx.$t('checkout.userEmail.validating')), 1 /* TEXT */)
                ]))
              : createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}
}

};

script$5.__scopeId = "data-v-9170ea10";
script$5.__file = "src/components/checkout/UserEmail.vue";

const _hoisted_1$4 = { class: "uk-card uk-card-body uk-align-center checkout-shipping" };


var script$4 = {
  __name: 'Shipping',
  props: {
    addressIsValid: String
},
  emits: ['section'],
  setup(__props, { emit: __emit }) {


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("h3", null, toDisplayString(_ctx.$t('checkout.shipping.title')), 1 /* TEXT */),
    createElementVNode("div", null, [
      _cache[0] || (_cache[0] = createElementVNode("input", {
        type: "radio",
        value: "standard",
        checked: ""
      }, null, -1 /* HOISTED */)),
      createTextVNode(" " + toDisplayString(_ctx.$t('checkout.shipping.standard')), 1 /* TEXT */)
    ])
  ]))
}
}

};

script$4.__file = "src/components/checkout/Shipping.vue";

const _hoisted_1$3 = { class: "uk-card uk-card-body uk-align-center checkout-payment" };
const _hoisted_2$2 = { class: "payment-title" };
const _hoisted_3$2 = {
  key: 0,
  class: "uk-alert-warning",
  "uk-alert": ""
};
const _hoisted_4$2 = {
  key: 1,
  class: "payment-grid"
};
const _hoisted_5$2 = ["title"];
const _hoisted_6$1 = ["value"];
const _hoisted_7$1 = {
  key: 0,
  class: "img-checked"
};
const _hoisted_8$1 = ["src", "alt"];
const _hoisted_9$1 = {
  key: 0,
  class: "payment-options-panel"
};
const _hoisted_10$1 = { class: "payment-options-title" };
const _hoisted_11$1 = { class: "uk-margin-small" };
const _hoisted_12$1 = { class: "uk-form-label" };
const _hoisted_13$1 = ["value"];
const _hoisted_14$1 = ["value"];
const _hoisted_15$1 = { value: "0" };
const _hoisted_16$1 = { class: "uk-margin-small" };
const _hoisted_17$1 = { class: "uk-form-label" };
const _hoisted_18$1 = ["value", "placeholder"];
const _hoisted_19$1 = { class: "uk-margin-small" };
const _hoisted_20$1 = { class: "uk-form-label" };
const _hoisted_21$1 = ["value", "placeholder"];
const _hoisted_22$1 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_23$1 = {
  key: 1,
  class: "uk-text-small iban-validation-row"
};
const _hoisted_24$1 = {
  key: 2,
  class: "uk-text-success uk-text-small iban-validation-row"
};
const _hoisted_25$1 = {
  key: 3,
  class: "uk-text-danger uk-text-small iban-validation-row"
};
const _hoisted_26$1 = { class: "delivery-nav-row" };
const _hoisted_27$1 = ["disabled"];


var script$3 = /*@__PURE__*/Object.assign({ name: 'CheckoutPayment' }, {
  __name: 'Payment',
  emits: ['section'],
  setup(__props, { emit: __emit }) {

const sessionStore = useSessionStore();
const authStore = useAuthStore();
const { user } = storeToRefs(authStore);
const { checkout, cart, parameter, bankaccounts } = storeToRefs(sessionStore);
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const fallbackPaymentMethods = ['paypal', 'rechnung', 'lastschrift'];
const paymentMethodOrder = Object.keys(paymentMap);
const bankaccountManager = new BankaccountManager();
const selectedBankaccount = ref({});
const ibanValidation = ref({
    status: 'idle',
    iban: '',
    bic: '',
    bankname: ''
});
const ibanValidationRequestId = ref(0);

const checkoutCartItems = computed(() => {
    if (Array.isArray(checkout.value?.cartItems) && checkout.value.cartItems.length > 0) {
        return checkout.value.cartItems
    }

    return Array.isArray(cart.value?.items) ? cart.value.items : []
});

const configuredPaymentMethods = computed(() => {
    const configured = parameter.value?.country?.payment ?? parameter.value?.county?.payment;
    const destinationCountry = String(checkout.value?.destinationCountry || 'DE').toUpperCase();

    if (Array.isArray(configured)) {
        return configured.map((method) => String(method).trim()).filter(Boolean)
    }

    if (typeof configured === 'string') {
        return configured.split(/\s+/).map((method) => method.trim()).filter(Boolean)
    }

    if (configured && typeof configured === 'object') {
        const countryMethods = configured[destinationCountry]
            || configured[destinationCountry.toLowerCase()]
            || configured.DE
            || configured.de
            || Object.values(configured).find((entry) => Array.isArray(entry));

        if (Array.isArray(countryMethods)) {
            return countryMethods.map((method) => String(method).trim()).filter(Boolean)
        }

        if (typeof countryMethods === 'string') {
            return countryMethods.split(/\s+/).map((method) => method.trim()).filter(Boolean)
        }
    }

    return fallbackPaymentMethods
});

const blockedPaymentMethods = computed(() => {
    const blocked = new Set();
    const paymentFilter = sessionStore.parameter?.product?.payment_filter;

    if (!paymentFilter || typeof paymentFilter !== 'object') {
        return blocked
    }

    checkoutCartItems.value.forEach((item) => {
        const pgrId = item?.product?.pgrId ?? item?.pgrId;
        if (typeof pgrId === 'undefined' || pgrId === null) return

        const blockedMethodsForGroup = paymentFilter[String(pgrId)];
        if (typeof blockedMethodsForGroup !== 'string' || !blockedMethodsForGroup.trim()) return

        blockedMethodsForGroup
            .split(/\s+/)
            .map((method) => method.trim().toLowerCase())
            .filter(Boolean)
            .forEach((method) => blocked.add(method));
    });

    return blocked
});

const payment = computed(() => {
    return configuredPaymentMethods.value
        .map((method) => method.toLowerCase())
        .filter((method, index, allMethods) => method && allMethods.indexOf(method) === index)
        .filter((method) => Boolean(paymentMap[method]))
        .filter((method) => !blockedPaymentMethods.value.has(method))
        .sort((a, b) => paymentMethodOrder.indexOf(a) - paymentMethodOrder.indexOf(b))
        .map((method) => ({
            name: method,
            icon: paymentMap[method]?.icon || null,
            createPayment: Boolean(paymentMap[method]?.createPayment)
        }))
});

const selectedPaymentTitle = computed(() => {
    const selected = String(checkout.value?.payment || '').toLowerCase();
    if (!selected) return ''

    const translationKey = `checkout.payment.methods.${selected}`;
    const translated = t(translationKey);

    return translated !== translationKey ? translated : selected
});

const hasPaymentOptions = computed(() => checkout.value?.payment === 'lastschrift');

const availableBankaccounts = computed(() => {
    const raw = bankaccounts.value?.rawData;
    return Array.isArray(raw) ? raw.filter((entry) => entry && entry.zid) : []
});

const normalizedBankaccount = computed(() => ({
    owner: String(selectedBankaccount.value?.owner || selectedBankaccount.value?.holderName || ''),
    iban: String(selectedBankaccount.value?.iban || '').replace(/\s+/g, '').toUpperCase()
}));

const isBankaccountValid = computed(() => {
    if (!hasPaymentOptions.value) return true

    return bankaccountSchema.isValidSync(normalizedBankaccount.value)
});

const isIbanApiValid = computed(() => {
    if (!hasPaymentOptions.value) return true
    return ibanValidation.value.status === 'valid'
});

const canContinueToConfirm = computed(() => {
    return Boolean(checkout.value?.payment) && isBankaccountValid.value && isIbanApiValid.value
});

function clearIbanValidation() {
    ibanValidation.value = {
        status: 'idle',
        iban: '',
        bic: '',
        bankname: ''
    };
}

function ensureIbanValidationForCurrentAccount() {
    const iban = String(normalizedBankaccount.value.iban || '').replace(/\s+/g, '').toUpperCase();

    if (!iban) {
        clearIbanValidation();
        return
    }

    if (!bankaccountSchema.isValidSync(normalizedBankaccount.value)) {
        ibanValidation.value = {
            status: 'invalid',
            iban,
            bic: '',
            bankname: ''
        };
        return
    }

    // Bereits geprueftes Ergebnis fuer dieselbe IBAN wiederverwenden.
    if (ibanValidation.value.status === 'valid' && ibanValidation.value.iban === iban) {
        return
    }

    // Laufende Pruefung fuer dieselbe IBAN nicht doppelt starten.
    if (ibanValidation.value.status === 'checking' && ibanValidation.value.iban === iban) {
        return
    }

    validateIbanByApi(iban);
}

async function validateIbanByApi(iban) {
    const requestId = ++ibanValidationRequestId.value;
    ibanValidation.value = {
        status: 'checking',
        iban,
        bic: '',
        bankname: ''
    };

    try {
        const res = await ppapiClient.post('payments/validateIBAN', { iban });

        if (requestId !== ibanValidationRequestId.value) return

        if (res?.valid) {
            ibanValidation.value = {
                status: 'valid',
                iban: String(res.iban || iban),
                bic: String(res.bic || ''),
                bankname: String(res.bankname || '')
            };
            return
        }

        ibanValidation.value = {
            status: 'invalid',
            iban,
            bic: '',
            bankname: ''
        };
    } catch (e) {
        if (requestId !== ibanValidationRequestId.value) return

        ibanValidation.value = {
            status: 'invalid',
            iban,
            bic: '',
            bankname: ''
        };
    }
}

const debouncedValidateIban = debounce((iban) => {
    if (!hasPaymentOptions.value) return
    if (normalizedBankaccount.value.iban !== iban) return
    validateIbanByApi(iban);
}, 1000);

function syncSelectedBankaccount(account) {
    const safeAccount = account && typeof account === 'object'
        ? { ...account }
        : { zid: null, owner: '', iban: '' };

    selectedBankaccount.value = safeAccount;
    checkout.value.bankaccount = safeAccount.zid || null;
}

async function initBankaccounts() {
    await bankaccountManager.init();
    syncSelectedBankaccount(bankaccountManager.bankaccount);
}

function updateBankaccountField(field, value) {
    const current = selectedBankaccount.value || {};
    const normalizedValue = field === 'iban'
        ? String(value || '').replace(/\s+/g, '').toUpperCase()
        : String(value || '');

    const updated = {
        ...current,
        [field]: normalizedValue,
        ...(field === 'owner' ? {
            holderName: normalizedValue,
            owner: normalizedValue
        } : {})
    };

    const cmd = current?.zid && !String(current.zid).startsWith('_') ? 'update' : undefined;
    const saved = bankaccountManager.setBankaccount(updated, cmd);
    syncSelectedBankaccount(saved);
}

function onBankaccountSelectionChange(event) {
    const zid = event?.target?.value;
    if (!zid) return

    if (zid === '0') {
        const added = bankaccountManager.addBankaccount();
        syncSelectedBankaccount(added);
        return
    }

    const selected = availableBankaccounts.value.find((entry) => String(entry.zid) === String(zid));
    if (!selected) return

    const applied = bankaccountManager.setBankaccount(selected);
    syncSelectedBankaccount(applied);
}

bankaccountManager.onBankaccountChange = (account) => {
    syncSelectedBankaccount(account);
};

onBeforeMount(() => {
    initBankaccounts().catch(() => {
        syncSelectedBankaccount(null);
    });
});

watch(payment, (availablePaymentMethods) => {
    const selectedPayment = checkout.value?.payment;
    const availableNames = availablePaymentMethods.map((method) => method.name);

    if (availableNames.length === 0) {
        checkout.value.payment = null;
        return
    }

    if (!selectedPayment || !availableNames.includes(String(selectedPayment).toLowerCase())) {
        checkout.value.payment = availableNames[0];
    }
}, { immediate: true });

watch(() => user.value?.kid, () => {
    initBankaccounts().catch(() => {
        syncSelectedBankaccount(null);
    });
});

watch(() => checkout.value?.payment, (method) => {
    if (method !== 'lastschrift') return

    if (!checkout.value?.bankaccount || !selectedBankaccount.value?.zid) {
        initBankaccounts().catch(() => {
            syncSelectedBankaccount(null);
        });
        return
    }

    ensureIbanValidationForCurrentAccount();
}, { immediate: true });

watch(() => normalizedBankaccount.value.iban, (ibanRaw) => {
    if (!hasPaymentOptions.value) {
        clearIbanValidation();
        return
    }

    const iban = String(ibanRaw || '').replace(/\s+/g, '').toUpperCase();
    if (!iban) {
        clearIbanValidation();
        return
    }

    if (iban.length < 15) {
        ibanValidation.value = {
            status: 'invalid',
            iban,
            bic: '',
            bankname: ''
        };
        return
    }

    debouncedValidateIban(iban);
});



return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$3, [
      createElementVNode("h3", _hoisted_2$2, toDisplayString(`${_ctx.$t('checkout.payment.title')}: ${selectedPaymentTitle.value || '-'}`), 1 /* TEXT */),
      (payment.value.length === 0)
        ? (openBlock(), createElementBlock("div", _hoisted_3$2, " Für die ausgewählten Produkte ist aktuell keine Zahlart verfügbar. "))
        : createCommentVNode("v-if", true),
      (payment.value.length > 0)
        ? (openBlock(), createElementBlock("div", _hoisted_4$2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(payment.value, (item, index) => {
              return (openBlock(), createElementBlock("label", {
                key: index,
                class: normalizeClass(["payment-tile", { selected: unref(checkout).payment === item.name }]),
                title: _ctx.$t(`checkout.payment.methods.${item.name}`)
              }, [
                withDirectives(createElementVNode("input", {
                  class: "payment-radio",
                  name: "payment",
                  type: "radio",
                  value: item.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((unref(checkout).payment) = $event))
                }, null, 8 /* PROPS */, _hoisted_6$1), [
                  [vModelRadio, unref(checkout).payment]
                ]),
                (unref(checkout).payment === item.name)
                  ? (openBlock(), createElementBlock("div", _hoisted_7$1, [...(_cache[5] || (_cache[5] = [
                      createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
                    ]))]))
                  : createCommentVNode("v-if", true),
                (item.icon)
                  ? (openBlock(), createElementBlock("img", {
                      key: 1,
                      src: item.icon,
                      alt: _ctx.$t(`checkout.payment.methods.${item.name}`),
                      class: "payment-icon"
                    }, null, 8 /* PROPS */, _hoisted_8$1))
                  : createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_5$2))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : createCommentVNode("v-if", true),
      createVNode(Transition, { name: "payment-options" }, {
        default: withCtx(() => [
          (hasPaymentOptions.value)
            ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
                createElementVNode("h4", _hoisted_10$1, toDisplayString(_ctx.$t('checkout.payment.options.lastschrift.title')), 1 /* TEXT */),
                createElementVNode("div", _hoisted_11$1, [
                  createElementVNode("label", _hoisted_12$1, toDisplayString(_ctx.$t('checkout.payment.options.lastschrift.savedAccounts')), 1 /* TEXT */),
                  createElementVNode("select", {
                    class: "uk-select",
                    value: unref(checkout).bankaccount || '',
                    onChange: onBankaccountSelectionChange
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(availableBankaccounts.value, (account, index) => {
                      return (openBlock(), createElementBlock("option", {
                        key: account.zid || index,
                        value: account.zid
                      }, toDisplayString(account.holderName || account.owner || _ctx.$t('checkout.payment.options.lastschrift.noOwner')) + " - " + toDisplayString(account.iban || '-'), 9 /* TEXT, PROPS */, _hoisted_14$1))
                    }), 128 /* KEYED_FRAGMENT */)),
                    createElementVNode("option", _hoisted_15$1, toDisplayString(_ctx.$t('checkout.payment.options.lastschrift.newOption')), 1 /* TEXT */)
                  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_13$1)
                ]),
                createElementVNode("div", _hoisted_16$1, [
                  createElementVNode("label", _hoisted_17$1, toDisplayString(_ctx.$t('checkout.payment.options.lastschrift.owner')), 1 /* TEXT */),
                  createElementVNode("input", {
                    class: "uk-input",
                    type: "text",
                    value: selectedBankaccount.value.owner || selectedBankaccount.value.holderName || '',
                    placeholder: _ctx.$t('checkout.payment.options.lastschrift.ownerPlaceholder'),
                    onInput: _cache[1] || (_cache[1] = $event => (updateBankaccountField('owner', $event.target.value)))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18$1)
                ]),
                createElementVNode("div", _hoisted_19$1, [
                  createElementVNode("label", _hoisted_20$1, toDisplayString(_ctx.$t('checkout.payment.options.lastschrift.iban')), 1 /* TEXT */),
                  createElementVNode("input", {
                    class: "uk-input",
                    type: "text",
                    value: selectedBankaccount.value.iban || '',
                    placeholder: _ctx.$t('checkout.payment.options.lastschrift.ibanPlaceholder'),
                    onInput: _cache[2] || (_cache[2] = $event => (updateBankaccountField('iban', $event.target.value)))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21$1)
                ]),
                (!isBankaccountValid.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_22$1, toDisplayString(_ctx.$t('checkout.payment.options.lastschrift.validation')), 1 /* TEXT */))
                  : createCommentVNode("v-if", true),
                (ibanValidation.value.status === 'checking')
                  ? (openBlock(), createElementBlock("div", _hoisted_23$1, _cache[6] || (_cache[6] = [
                      createElementVNode("span", { "uk-spinner": "ratio: 0.5" }, null, -1 /* HOISTED */),
                      createElementVNode("span", null, "IBAN wird geprüft...", -1 /* HOISTED */)
                    ])))
                  : createCommentVNode("v-if", true),
                (ibanValidation.value.status === 'valid')
                  ? (openBlock(), createElementBlock("div", _hoisted_24$1, [
                      _cache[7] || (_cache[7] = createElementVNode("span", {
                        class: "iban-validation-icon",
                        "uk-icon": "icon: check"
                      }, null, -1 /* HOISTED */)),
                      createElementVNode("span", null, "IBAN gültig" + toDisplayString(ibanValidation.value.bic ? ` - ${ibanValidation.value.bic}` : '') + toDisplayString(ibanValidation.value.bankname ? `, ${ibanValidation.value.bankname}` : ''), 1 /* TEXT */)
                    ]))
                  : createCommentVNode("v-if", true),
                (ibanValidation.value.status === 'invalid')
                  ? (openBlock(), createElementBlock("div", _hoisted_25$1, _cache[8] || (_cache[8] = [
                      createElementVNode("span", {
                        class: "iban-validation-icon",
                        "uk-icon": "icon: close"
                      }, null, -1 /* HOISTED */),
                      createElementVNode("span", null, "IBAN ungültig", -1 /* HOISTED */)
                    ])))
                  : createCommentVNode("v-if", true)
              ]))
            : createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    createElementVNode("div", _hoisted_26$1, [
      createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = $event => (emit('section', 'delivery'))),
        class: "cart-button uk-button uk-button-default uk-button-small"
      }, toDisplayString(_ctx.$t('checkout.common.backToShippingOptions')), 1 /* TEXT */),
      createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = $event => (emit('section', 'confirm'))),
        disabled: !canContinueToConfirm.value,
        class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary"
      }, toDisplayString(_ctx.$t('checkout.common.continueToOrderSummary')), 9 /* TEXT, PROPS */, _hoisted_27$1)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

});

script$3.__scopeId = "data-v-97eba8a6";
script$3.__file = "src/components/checkout/Payment.vue";

const _hoisted_1$2 = { class: "cart-confirm uk-card uk-card-body uk-align-center" };
const _hoisted_2$1 = {
  key: 0,
  class: "uk-alert-warning payment-cancel-warning",
  "uk-alert": ""
};
const _hoisted_3$1 = {
  key: 1,
  class: "auto-confirm-status-box"
};
const _hoisted_4$1 = { class: "auto-confirm-status-title" };
const _hoisted_5$1 = { class: "auto-confirm-status-spinner-wrap" };
const _hoisted_6 = {
  key: 0,
  "uk-spinner": "ratio: 1.2"
};
const _hoisted_7 = {
  key: 0,
  class: "uk-alert-warning order-activation-warning",
  "uk-alert": ""
};
const _hoisted_8 = { class: "auto-confirm-status-actions" };
const _hoisted_9 = { key: 3 };
const _hoisted_10 = { class: "confirm-summary-block" };
const _hoisted_11 = { class: "confirm-summary-card confirm-summary-address" };
const _hoisted_12 = { class: "confirm-summary-label" };
const _hoisted_13 = {
  key: 0,
  class: "confirm-summary-card confirm-summary-address"
};
const _hoisted_14 = { class: "confirm-summary-label" };
const _hoisted_15 = { class: "confirm-summary-card confirm-summary-payment" };
const _hoisted_16 = { class: "confirm-summary-label" };
const _hoisted_17 = { class: "confirm-summary-line" };
const _hoisted_18 = {
  key: 0,
  class: "confirm-summary-line"
};
const _hoisted_19 = {
  key: 1,
  class: "confirm-summary-line"
};
const _hoisted_20 = { class: "uk-table uk-table-small uk-table-divider cart" };
const _hoisted_21 = { colspan: "2" };
const _hoisted_22 = { class: "uk-align-right uk-margin-remove" };
const _hoisted_23 = { class: "large-view uk-text-right" };
const _hoisted_24 = { class: "uk-text-right" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { class: "pid uk-text-small" };
const _hoisted_27 = { class: "item-options" };
const _hoisted_28 = { class: "small-view singleprice-row" };
const _hoisted_29 = { class: "uk-text-right" };
const _hoisted_30 = {
  key: 0,
  class: "large-view uk-text-right"
};
const _hoisted_31 = { key: 1 };
const _hoisted_32 = { class: "uk-text-right" };
const _hoisted_33 = { class: "tr-small-view" };
const _hoisted_34 = { colspan: "2" };
const _hoisted_35 = { class: "uk-text-right" };
const _hoisted_36 = { class: "tr-large-view" };
const _hoisted_37 = { colspan: "3" };
const _hoisted_38 = { class: "uk-text-right" };
const _hoisted_39 = { key: 0 };
const _hoisted_40 = {
  key: 0,
  class: "pid uk-text-small"
};
const _hoisted_41 = { class: "small-view singleprice-row" };
const _hoisted_42 = { class: "uk-text-right" };
const _hoisted_43 = {
  key: 0,
  class: "large-view uk-text-right"
};
const _hoisted_44 = { key: 1 };
const _hoisted_45 = { class: "uk-text-right" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { class: "uk-text-right" };
const _hoisted_48 = {
  key: 0,
  class: "large-view uk-text-right"
};
const _hoisted_49 = { key: 1 };
const _hoisted_50 = { class: "uk-text-right" };
const _hoisted_51 = { class: "tr-small-view" };
const _hoisted_52 = { colspan: "2" };
const _hoisted_53 = { class: "uk-text-right total-price-cell" };
const _hoisted_54 = {
  key: 0,
  class: "total-vat-note"
};
const _hoisted_55 = { class: "tr-large-view" };
const _hoisted_56 = { colspan: "3" };
const _hoisted_57 = { class: "uk-text-right total-price-cell" };
const _hoisted_58 = {
  key: 0,
  class: "total-vat-note"
};
const _hoisted_59 = {
  key: 0,
  class: "delivery-nav-row"
};


var script$2 = /*@__PURE__*/Object.assign({ name: 'CheckoutConfirm' }, {
  __name: 'Confirm',
  emits: ['section'],
  setup(__props, { emit: __emit }) {

const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

const sessionStore = useSessionStore();
const authStore = useAuthStore();
const alertStore = useAlertStore();
const configStore = useConfigStore();
const route = useRoute();
const router = useRouter();
const { t } = useI18n({ useScope: 'global' });
const { cart, checkout, bankaccounts, parameter } = storeToRefs(sessionStore);

sessionStore.normalizeCart();

const cartValue = Array.isArray(sessionStore.cart)
    ? { id: null, sessionId: null, items: sessionStore.cart }
    : sessionStore.cart;
const checkoutCartItems = Array.isArray(checkout.value?.cartItems) && checkout.value.cartItems.length > 0
    ? checkout.value.cartItems
    : toRaw(cartValue.items);

const emit = __emit;

const response = ref(new apiResponse([]));
const processing = ref(false);
const autoConfirmHandled = ref(false);
const autoConfirmInProgress = ref(false);
const autoConfirmResultReady = ref(false);
const currentRouteQuery = computed(() => route?.query || {});
const currentRoutePath = computed(() => route?.path || '/shop/checkout');
const isAutoConfirmReturn = computed(() => String(currentRouteQuery.value?.payment || '').toLowerCase() === 'confirm');
const isPaymentCancelReturn = computed(() => String(currentRouteQuery.value?.payment || '').toLowerCase() === 'cancel');
const showPaymentCancelWarning = ref(isPaymentCancelReturn.value);
const showAutoConfirmStatus = computed(() => autoConfirmInProgress.value || autoConfirmResultReady.value || (isAutoConfirmReturn.value && processing.value));
const report = computed(() => response.value?.report || null);
const activationSentTo = computed(() => String(response.value?.activationSentTo || '').trim());
const totalVatAmount = computed(() => {
    const vat = Number(report.value?.invoice?.total?.vat);
    return Number.isFinite(vat) ? vat : null
});
const totalVatLabel = computed(() => {
    if (totalVatAmount.value === null) return ''
    return `inkl. ${fmt.format(totalVatAmount.value)} MwSt.`
});

const order = new Order(
    toRaw(cartValue.id)
);

order.setCart(toRaw(checkoutCartItems));
order.setCheckout(toRaw(sessionStore.checkout));

if (order.init()) {
    if (isAutoConfirmReturn.value) {
        // Bei Rückkehr vom Payment direkt zur finalen Bestellung ohne erneute Validate-Zusammenfassung.
        processing.value = true;
    } else {
        processing.value = "validating";
        order.validate().then((res) => {
            logger.debug(res);
            processing.value = false;
            response.value = res;
            if (res?.cartId) {
                cart.value.id = res.cartId;
                order.conf.cartId = res.cartId;
            }
        }).catch((e) => {
            logger.error(['error validating order', e]);
            processing.value = false;
            alertStore.error(e?.message || e || order.error?.at(-1) || 'Fehler bei der Validierung der Bestellung.', 'checkout');
        });
    }
} else {
    alertStore.error(order.error, 'checkout');
}

const selectedPaymentConfig = computed(() => {
    const selectedMethod = String(checkout.value?.payment || '').toLowerCase();
    return paymentMap[selectedMethod] || null
});

const shouldCreatePayment = computed(() => Boolean(selectedPaymentConfig.value?.createPayment));
const selectedPaymentMethod = computed(() => {
    const selected = String(checkout.value?.payment || '').toLowerCase();
    return selectedPaymentConfig.value?.method || selected || null
});

const selectedCaptureMode = computed(() => {
    const selected = String(checkout.value?.payment || '').toLowerCase();
    return selectedPaymentConfig.value?.captureMode || selected || "automatic"
});

const availableBankaccounts = computed(() => {
    const raw = bankaccounts.value?.rawData;
    return Array.isArray(raw) ? raw.filter((entry) => entry && entry.zid) : []
});

function resolveCountryLabel(address) {
    if (!address) return ''
    const countryCode = address.countryISO || address.country || '';
    return parameter.value?.country?.country_list?.[countryCode] || countryCode
}

function getAddressLines(address) {
    if (!address) return []

    return [
        address.company,
        [address.firstname, address.lastname].filter(Boolean).join(' ').trim(),
        address.ustid ? `USt-IdNr.: ${address.ustid}` : '',
        address.street,
        address.supplement,
        [address.zip, address.city || address.ort].filter(Boolean).join(' ').trim(),
        resolveCountryLabel(address)
    ].filter((line) => String(line || '').trim())
}

const invoiceAddress = computed(() => report.value?.invoiceAddress || null);
const deliveryAddress = computed(() => {
    if (!report.value?.altDelivery && !checkout.value?.altDelivery) return null
    if (report.value?.shippingAddress) return report.value.shippingAddress

    const deliveryAddressId = checkout.value?.addresses?.L;
    const addressList = Array.isArray(sessionStore.addresses?.rawData)
        ? sessionStore.addresses.rawData
        : [];

    return addressList.find((address) => address?.sid == deliveryAddressId) || null
});

const selectedPaymentName = computed(() => String(checkout.value?.payment || '').toLowerCase());
const selectedPaymentLabel = computed(() => {
    const method = selectedPaymentName.value;
    if (!method) return ''

    const translationKey = `checkout.payment.methods.${method}`;
    const translated = t(translationKey);
    return translated !== translationKey ? translated : method
});

const selectedBankaccount = computed(() => {
    const zid = checkout.value?.bankaccount;
    if (!zid) return null
    return availableBankaccounts.value.find((entry) => String(entry.zid) === String(zid)) || null
});

const selectedBankaccountOwner = computed(() => {
    return String(selectedBankaccount.value?.owner || selectedBankaccount.value?.holderName || '').trim()
});

const selectedBankaccountMaskedIban = computed(() => {
    const iban = String(selectedBankaccount.value?.iban || '').replace(/\s+/g, '').toUpperCase();
    if (!iban) return ''
    return iban.slice(-4)
});

function extractPaymentUrl(paymentResponse) {
    return paymentResponse?.mollieUrl
        || paymentResponse?.url
        || paymentResponse?.checkoutUrl
        || paymentResponse?.paymentUrl
        || paymentResponse?.data?.mollieUrl
        || paymentResponse?.data?.url
        || paymentResponse?.data?.checkoutUrl
        || paymentResponse?.data?.paymentUrl
        || null
}

function resolvePaymentError(error) {
    const paymentStatus = String(error?.response?.PaymentStatus || '').toLowerCase();
    const paymentStatusMessages = {
        canceled: t('checkout.payment.errors.canceled'),
        failed: t('checkout.payment.errors.failed')
    };

    return paymentStatusMessages[paymentStatus]
        || error?.response?.Error
        || error?.response?.error
        || error?.response?.message
        || error?.message
        || t('checkout.payment.errors.generic')
}

function buildRedirectUrl() {
    const target = router.resolve({
        path: currentRoutePath.value,
        query: {
            ...currentRouteQuery.value,
            payment: 'confirm'
        }
    });

    return `${window.location.origin}${target.href}`
}

function buildCancelUrl() {

    const baseDir = configStore.baseDir || '';

    return `${window.location.origin}${baseDir}/checkout?payment=cancel`
}

async function createPaymentByCheckoutId() {
    const checkoutId = sessionStore.checkout?.checkoutId;
    const kid = authStore.user?.kid || 0;

    if (!checkoutId) {
        logger.error('Missing checkoutId for paymentByCheckoutId');
        emit('section', 'error');
        return
    }

    if (!selectedPaymentMethod.value) {
        logger.error('Missing method for paymentByCheckoutId');
        emit('section', 'error');
        return
    }

    processing.value = true;

    try {
        const res = await ppapiClient.post('payments/paymentByCheckoutId', {
            checkoutId,
            kid,
            cartId: order.conf?.cartId || null,
            redirectUrl: buildRedirectUrl(),
            cancelUrl: buildCancelUrl(),
            captureMode: selectedCaptureMode.value,
            method: selectedPaymentMethod.value
        });

        response.value = res;

        const mollieUrl = extractPaymentUrl(res);

        if (!mollieUrl) {
            logger.error(['No payment URL returned from paymentByCheckoutId', res]);
            emit('section', 'error');
            return
        }

        window.location.href = mollieUrl;
    } catch (e) {
        logger.error(['error creating checkout payment', e]);
        emit('section', 'error');
    } finally {
        processing.value = false;
    }
}


function sendOrder(extraPayload = {}, options = {}) {
    const { lockAutoConfirmStatus = false, inlineSuccessAcknowledge = false } = options;

    processing.value = true;
    order.sendByCartId(extraPayload).then((res) => {
        logger.debug(res);
        response.value = res;
        if (res?.orderId) {
            const orderedItemsSnapshot = Array.isArray(checkout.value?.cartItems)
                ? JSON.parse(JSON.stringify(toRaw(checkout.value.cartItems)))
                : [];

            if (orderedItemsSnapshot.length > 0) {
                // Clientseitiger Fallback (z.B. Gast ohne kid): nur bestellte Revisionen entfernen.
                sessionStore.removeOrderedCartItems(orderedItemsSnapshot);
            } else {
                sessionStore.checkout.checkoutId = null;
                sessionStore.checkout.cartItems = [];
            }

            const currentKid = authStore.user?.kid;
            if (currentKid) {
                sessionStore.syncCartFromServer(currentKid, { authoritative: true })
                    .catch((e) => logger.warn('Failed to sync cart after order', e));
            }
            logger.info(`orderId ${res.orderId}`);
            if (inlineSuccessAcknowledge) {
                autoConfirmResultReady.value = true;
            } else {
                emit('section', 'success', { activationSentTo: activationSentTo.value });
            }
        } else {
            logger.error(["error processing order",res]);
            emit('section', 'error');
        }
    }).catch((e) => {
        logger.error(['error processing order', e]);
        alertStore.error(resolvePaymentError(e), 'checkout');
    }).finally(() => {
        processing.value = false;
        if (lockAutoConfirmStatus) {
            autoConfirmInProgress.value = false;
        }
    });

}

function completePurchase() {
    showPaymentCancelWarning.value = false;

    if (shouldCreatePayment.value) {
        createPaymentByCheckoutId();
        return
    }

    sendOrder();
}

function removePaymentQueryParam() {
    const nextQuery = { ...currentRouteQuery.value };
    delete nextQuery.payment;
    router.replace({ path: currentRoutePath.value, query: nextQuery }).catch(() => {});
}

function handlePaymentCancelReturn() {
    if (!isPaymentCancelReturn.value) {
        return
    }

    showPaymentCancelWarning.value = true;
    removePaymentQueryParam();
}

function backToPayment() {
    showPaymentCancelWarning.value = false;
    emit('section','payment');
}

function autoSubmitConfirmOrder() {
    const paymentParam = String(currentRouteQuery.value?.payment || '').toLowerCase();

    if (paymentParam !== 'confirm' || autoConfirmHandled.value) {
        return
    }

    autoConfirmHandled.value = true;
    autoConfirmInProgress.value = true;
    removePaymentQueryParam();

    sendOrder(
        { confirmPayment: 1 },
        { lockAutoConfirmStatus: true, inlineSuccessAcknowledge: true }
    );
}

function onAutoConfirmSuccessOk() {
    redirectAction(configStore.orderSuccessRedirect, router);
}

onBeforeMount(() => {
    autoSubmitConfirmOrder();
    handlePaymentCancelReturn();
});

watch(() => currentRouteQuery.value?.payment, () => {
    autoSubmitConfirmOrder();
    handlePaymentCancelReturn();
});

function getProductOptionNames(item) {
    const productOptions = Array.isArray(item?.productOptions)
        ? item.productOptions
        : (item?.productOptions ? [item.productOptions] : []);

    return productOptions
        .filter((option) => {
            if (option && typeof option === 'object') {
                return Number(option.po) !== 0 && option.name !== 'not_set'
            }

            return Number(option) !== 0 && option !== 'not_set'
        })
        .map((option) => {
            if (option && typeof option === 'object') {
                const name = option.name ?? option.label ?? option.title ?? '';
                const value = option.value ?? option.val ?? '';
                const normalizedName = String(name || '').trim();
                const normalizedValue = String(value || '').trim();

                if (normalizedName && normalizedValue) return `${normalizedName} ${normalizedValue}`
                if (normalizedName) return normalizedName
                if (normalizedValue) return normalizedValue
                if (typeof option.po !== 'undefined' && option.po !== null && option.po !== '') return String(option.po)
                return null
            }

            if (option === null || typeof option === 'undefined' || option === '') {
                return null
            }

            return String(option)
        })
        .filter((optionName, optionIndex, allNames) => optionName && allNames.indexOf(optionName) === optionIndex)
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$2, [
      (showPaymentCancelWarning.value && !showAutoConfirmStatus.value)
        ? (openBlock(), createElementBlock("div", _hoisted_2$1, " Bezahlvorgang abgebrochen "))
        : createCommentVNode("v-if", true),
      (showAutoConfirmStatus.value)
        ? (openBlock(), createElementBlock("div", _hoisted_3$1, [
            createElementVNode("div", _hoisted_4$1, toDisplayString(autoConfirmResultReady.value
                    ? (_ctx.$t('checkout.confirm.orderCompleted') !== 'checkout.confirm.orderCompleted'
                        ? _ctx.$t('checkout.confirm.orderCompleted')
                        : 'Bestellung abgeschlossen')
                    : (_ctx.$t('checkout.confirm.processingOrder') !== 'checkout.confirm.processingOrder'
                        ? _ctx.$t('checkout.confirm.processingOrder')
                        : 'Bestellung wird ausgeführt')), 1 /* TEXT */),
            createElementVNode("div", _hoisted_5$1, [
              (!autoConfirmResultReady.value)
                ? (openBlock(), createElementBlock("div", _hoisted_6))
                : createCommentVNode("v-if", true)
            ]),
            (autoConfirmResultReady.value && activationSentTo.value)
              ? (openBlock(), createElementBlock("div", _hoisted_7, toDisplayString(_ctx.$t('checkout.confirm.activationRequired', { email: activationSentTo.value })), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_8, [
              (autoConfirmResultReady.value)
                ? (openBlock(), createElementBlock("button", {
                    key: 0,
                    onClick: onAutoConfirmSuccessOk,
                    class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary"
                  }, toDisplayString(_ctx.$t('ok') !== 'ok' ? _ctx.$t('ok') : 'OK'), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ])
          ]))
        : (processing.value)
          ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: normalizeClass(["auto-confirm-status-box", {'validating': processing.value === 'validating'}])
            }, _cache[1] || (_cache[1] = [
              createElementVNode("div", { class: "auto-confirm-status-spinner-wrap" }, [
                createElementVNode("div", { "uk-spinner": "ratio: 1.2" })
              ], -1 /* HOISTED */),
              createElementVNode("div", { class: "auto-confirm-status-actions" }, null, -1 /* HOISTED */)
            ]), 2 /* CLASS */))
          : createCommentVNode("v-if", true),
      (response.value.report && unref(_).size(response.value.report.invoice.items) > 0 && !processing.value > 0 && !showAutoConfirmStatus.value)
        ? (openBlock(), createElementBlock("div", _hoisted_9, [
            createElementVNode("h3", null, toDisplayString(_ctx.$t('checkout.confirm.title')), 1 /* TEXT */),
            createElementVNode("div", _hoisted_10, [
              createElementVNode("div", _hoisted_11, [
                createElementVNode("div", _hoisted_12, toDisplayString(_ctx.$t('checkout.addresses.billingAddress')), 1 /* TEXT */),
                (openBlock(true), createElementBlock(Fragment, null, renderList(getAddressLines(invoiceAddress.value), (line, index) => {
                  return (openBlock(), createElementBlock("div", {
                    key: `invoice-${index}`,
                    class: "confirm-summary-line"
                  }, toDisplayString(line), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              (deliveryAddress.value)
                ? (openBlock(), createElementBlock("div", _hoisted_13, [
                    createElementVNode("div", _hoisted_14, toDisplayString(_ctx.$t('checkout.addresses.deliveryAddress')), 1 /* TEXT */),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(getAddressLines(deliveryAddress.value), (line, index) => {
                      return (openBlock(), createElementBlock("div", {
                        key: `delivery-${index}`,
                        class: "confirm-summary-line"
                      }, toDisplayString(line), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : createCommentVNode("v-if", true),
              createElementVNode("div", _hoisted_15, [
                createElementVNode("div", _hoisted_16, toDisplayString(_ctx.$t('checkout.payment.title')), 1 /* TEXT */),
                createElementVNode("div", _hoisted_17, toDisplayString(selectedPaymentLabel.value || '-'), 1 /* TEXT */),
                (selectedPaymentName.value === 'lastschrift' && selectedBankaccountOwner.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_18, toDisplayString(selectedBankaccountOwner.value), 1 /* TEXT */))
                  : createCommentVNode("v-if", true),
                (selectedPaymentName.value === 'lastschrift' && selectedBankaccountMaskedIban.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_19, " IBAN •••• " + toDisplayString(selectedBankaccountMaskedIban.value), 1 /* TEXT */))
                  : createCommentVNode("v-if", true)
              ])
            ]),
            createElementVNode("table", _hoisted_20, [
              createElementVNode("thead", null, [
                createElementVNode("tr", null, [
                  createElementVNode("th", _hoisted_21, [
                    createTextVNode(toDisplayString(_ctx.$t('checkout.confirm.items')) + " ", 1 /* TEXT */),
                    createElementVNode("div", _hoisted_22, toDisplayString(_ctx.$t('checkout.cart.quantity')), 1 /* TEXT */)
                  ]),
                  createElementVNode("th", _hoisted_23, toDisplayString(_ctx.$t('checkout.cart.unitPrice')), 1 /* TEXT */),
                  createElementVNode("th", _hoisted_24, toDisplayString(_ctx.$t('price')), 1 /* TEXT */)
                ])
              ]),
              createElementVNode("tbody", null, [
                createCommentVNode(" Artikel "),
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(_).filter(response.value.report.invoice.items, { type: 10 }), (item, index) => {
                  return (openBlock(), createElementBlock(Fragment, { key: index }, [
                    (item.pid)
                      ? (openBlock(), createElementBlock("tr", _hoisted_25, [
                          createElementVNode("td", null, [
                            createElementVNode("div", null, [
                              createTextVNode(toDisplayString(item.productName) + " " + toDisplayString(item.productSize) + " " + toDisplayString(item.productSurface) + " ", 1 /* TEXT */),
                              createElementVNode("span", _hoisted_26, "(" + toDisplayString(_ctx.$t('checkout.cart.articleNumber', { pid: item.pid })) + ")", 1 /* TEXT */)
                            ]),
                            createElementVNode("div", _hoisted_27, [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(getProductOptionNames(item), (optionName, optionIndex) => {
                                return (openBlock(), createElementBlock("span", {
                                  key: `${item.pid}-${optionName}-${optionIndex}`,
                                  class: "product-option"
                                }, toDisplayString(_ctx.$t('product.' + optionName) !== ('product.' + optionName)
                                            ? _ctx.$t('product.' + optionName)
                                            : optionName), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            createElementVNode("div", _hoisted_28, toDisplayString(_ctx.$t('checkout.cart.unitPrice')) + ": " + toDisplayString(unref(fmt).format(item.singleprice)), 1 /* TEXT */)
                          ]),
                          createElementVNode("td", _hoisted_29, toDisplayString(item.quantity), 1 /* TEXT */),
                          (item.singleprice)
                            ? (openBlock(), createElementBlock("td", _hoisted_30, toDisplayString(unref(fmt).format(item.singleprice)), 1 /* TEXT */))
                            : (openBlock(), createElementBlock("td", _hoisted_31)),
                          createElementVNode("td", _hoisted_32, toDisplayString(unref(fmt).format(item.price)), 1 /* TEXT */)
                        ]))
                      : createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */)),
                _cache[2] || (_cache[2] = createElementVNode("tr", null, [
                  createElementVNode("td", {
                    colspan: "5",
                    style: {"padding":"2px"}
                  })
                ], -1 /* HOISTED */)),
                createElementVNode("tr", _hoisted_33, [
                  createElementVNode("td", _hoisted_34, toDisplayString(_ctx.$t('checkout.confirm.productValue')), 1 /* TEXT */),
                  createElementVNode("td", _hoisted_35, toDisplayString(unref(fmt).format(response.value.report.invoice.items.productTotal.price)), 1 /* TEXT */)
                ]),
                createElementVNode("tr", _hoisted_36, [
                  createElementVNode("td", _hoisted_37, toDisplayString(_ctx.$t('checkout.confirm.productValue')), 1 /* TEXT */),
                  createElementVNode("td", _hoisted_38, toDisplayString(unref(fmt).format(response.value.report.invoice.items.productTotal.price)), 1 /* TEXT */)
                ]),
                createCommentVNode(" Versandkalkulation (Versandkosten, Verpackungspauchale, Express, etc) "),
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(_).filter(response.value.report.invoice.items, { type: 20 }), (item, index) => {
                  return (openBlock(), createElementBlock(Fragment, { key: index }, [
                    (item && item.customerVisible !== false)
                      ? (openBlock(), createElementBlock("tr", _hoisted_39, [
                          createElementVNode("td", null, [
                            createTextVNode(toDisplayString(item.productName) + " " + toDisplayString(item.productSize) + " " + toDisplayString(item.productSurface) + " ", 1 /* TEXT */),
                            (item.pid)
                              ? (openBlock(), createElementBlock("span", _hoisted_40, "(" + toDisplayString(_ctx.$t('checkout.cart.articleNumber', { pid: item.pid })) + ")", 1 /* TEXT */))
                              : createCommentVNode("v-if", true),
                            createElementVNode("div", _hoisted_41, toDisplayString(_ctx.$t('checkout.cart.unitPrice')) + ": " + toDisplayString(unref(fmt).format(item.singleprice)), 1 /* TEXT */)
                          ]),
                          createElementVNode("td", _hoisted_42, toDisplayString(item.quantity), 1 /* TEXT */),
                          (item.singleprice)
                            ? (openBlock(), createElementBlock("td", _hoisted_43, toDisplayString(unref(fmt).format(item.singleprice)), 1 /* TEXT */))
                            : (openBlock(), createElementBlock("td", _hoisted_44)),
                          createElementVNode("td", _hoisted_45, toDisplayString(unref(fmt).format(item.price)), 1 /* TEXT */)
                        ]))
                      : createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */)),
                createCommentVNode(" Gutschriften "),
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(_).filter(response.value.report.invoice.items, { type: 30 }), (item, index) => {
                  return (openBlock(), createElementBlock(Fragment, { key: index }, [
                    (item && item.customerVisible !== false)
                      ? (openBlock(), createElementBlock("tr", _hoisted_46, [
                          createElementVNode("td", null, toDisplayString(item.productName) + " " + toDisplayString(item.productSize) + " " + toDisplayString(item.productSurface), 1 /* TEXT */),
                          createElementVNode("td", _hoisted_47, toDisplayString(item.quantity), 1 /* TEXT */),
                          (item.singleprice)
                            ? (openBlock(), createElementBlock("td", _hoisted_48, toDisplayString(unref(fmt).format(item.singleprice)), 1 /* TEXT */))
                            : (openBlock(), createElementBlock("td", _hoisted_49)),
                          createElementVNode("td", _hoisted_50, toDisplayString(unref(fmt).format(item.price)), 1 /* TEXT */)
                        ]))
                      : createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              createElementVNode("tfoot", null, [
                createElementVNode("tr", _hoisted_51, [
                  createElementVNode("td", _hoisted_52, toDisplayString(_ctx.$t('checkout.cart.total')), 1 /* TEXT */),
                  createElementVNode("td", _hoisted_53, [
                    createElementVNode("div", null, toDisplayString(unref(fmt).format(response.value.report.invoice.total.price)), 1 /* TEXT */),
                    (totalVatLabel.value)
                      ? (openBlock(), createElementBlock("div", _hoisted_54, toDisplayString(totalVatLabel.value), 1 /* TEXT */))
                      : createCommentVNode("v-if", true)
                  ])
                ]),
                createElementVNode("tr", _hoisted_55, [
                  createElementVNode("td", _hoisted_56, toDisplayString(_ctx.$t('checkout.cart.total')), 1 /* TEXT */),
                  createElementVNode("td", _hoisted_57, [
                    createElementVNode("div", null, toDisplayString(unref(fmt).format(response.value.report.invoice.total.price)), 1 /* TEXT */),
                    (totalVatLabel.value)
                      ? (openBlock(), createElementBlock("div", _hoisted_58, toDisplayString(totalVatLabel.value), 1 /* TEXT */))
                      : createCommentVNode("v-if", true)
                  ])
                ])
              ])
            ])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    (!showAutoConfirmStatus.value && !processing.value && response.value.report && unref(_).size(response.value.report.invoice.items) > 0)
      ? (openBlock(), createElementBlock("div", _hoisted_59, [
          createElementVNode("button", {
            onClick: backToPayment,
            class: "cart-button uk-button uk-button-default uk-button-small"
          }, toDisplayString(_ctx.$t('checkout.common.backToPayment')), 1 /* TEXT */),
          createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => (completePurchase())),
            class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary"
          }, toDisplayString(_ctx.$t('checkout.common.completePurchase')), 1 /* TEXT */)
        ]))
      : createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

});

script$2.__file = "src/components/checkout/Confirm.vue";

const _hoisted_1$1 = { class: "cart-success uk-card uk-card-body uk-align-center" };
const _hoisted_2 = { class: "auto-confirm-status-box" };
const _hoisted_3 = { class: "auto-confirm-status-title" };
const _hoisted_4 = {
  key: 0,
  class: "uk-alert-warning order-activation-warning",
  "uk-alert": ""
};
const _hoisted_5 = { class: "auto-confirm-status-actions" };


var script$1 = /*@__PURE__*/Object.assign({ name: 'CheckoutSuccess' }, {
  __name: 'Success',
  props: {
    activationSentTo: {
        type: String,
        default: ''
    }
},
  emits: ['section'],
  setup(__props, { emit: __emit }) {


const router = useRouter();
const configStore = useConfigStore();




const emit = __emit;

function ok() {

    emit("section", "cart");
    redirectAction(configStore.orderSuccessRedirect, router);

}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("div", _hoisted_2, [
      createElementVNode("div", _hoisted_3, toDisplayString(_ctx.$t('checkout.confirm.orderCompleted') !== 'checkout.confirm.orderCompleted'
                    ? _ctx.$t('checkout.confirm.orderCompleted')
                    : 'Bestellung abgeschlossen'), 1 /* TEXT */),
      _cache[1] || (_cache[1] = createElementVNode("div", { class: "auto-confirm-status-spinner-wrap" }, null, -1 /* HOISTED */)),
      (__props.activationSentTo)
        ? (openBlock(), createElementBlock("div", _hoisted_4, toDisplayString(_ctx.$t('checkout.confirm.activationRequired', { email: __props.activationSentTo })), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      createElementVNode("div", _hoisted_5, [
        createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => (ok())),
          class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary"
        }, toDisplayString(_ctx.$t('ok') !== 'ok' ? _ctx.$t('ok') : 'OK'), 1 /* TEXT */)
      ])
    ])
  ]))
}
}

});

script$1.__file = "src/components/checkout/Success.vue";

const _hoisted_1 = { class: "uk-card uk-card-body uk-align-center" };


var script = {
  __name: 'Error',
  emits: ['section'],
  setup(__props, { emit: __emit }) {


const emit = __emit;


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("h3", null, toDisplayString(_ctx.$t('checkout.error.title')), 1 /* TEXT */),
    createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = $event => (emit('section', 'cart'))),
      class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary uk-margin-right"
    }, toDisplayString(_ctx.$t('checkout.common.backToCart')), 1 /* TEXT */)
  ]))
}
}

};

script.__file = "src/components/checkout/Error.vue";

export { script$7 as a, script$6 as b, script$5 as c, script$4 as d, script$3 as e, script$2 as f, script$1 as g, script as h, script$8 as s };
